import { render, staticRenderFns } from "./ExaminationPaper.vue?vue&type=template&id=0de5b6fc&scoped=true&"
import script from "./ExaminationPaper.vue?vue&type=script&lang=js&"
export * from "./ExaminationPaper.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationPaper.vue?vue&type=style&index=0&id=0de5b6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5b6fc",
  null
  
)

export default component.exports